// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ProjectSchema } from './v1/projectSchema';
import { v1ProjectsCreateSchema } from './v1/projects/createSchema';

export const createProjectPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
});

export const createProjectHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description project created
 */
export const createProject201Schema = z.lazy(() => v1ProjectSchema);

export const createProjectMutationRequestSchema = z.lazy(() => v1ProjectsCreateSchema);

export const createProjectMutationResponseSchema = z.lazy(() => createProject201Schema);
